export default {
  username: '用户名',
  password: '密码',
  idCard: '身份证',
  phone: '手机号',
  money: '金额',
  AccountIn: '收款账户',
  AccountOut: '付款账户',
  captcha: '验证码',
  bankCard: '银行卡号'
}



// WEBPACK FOOTER //
// ./src/plugins/vee-validate/attributes.js